import * as React from 'react'
import {ContactForm} from './ContactForm'

export const AISolutionContact = () => {
  const scrollTo = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()

    const id = e.currentTarget.hash

    window.history.pushState(null, null, id)
    document.querySelector(id).scrollIntoView({behavior: 'smooth'})
  }

  return (
    <div className='AI__contact'>
      <div className='AI__contact__content'>
        <p>ทั้งนี้ หากบริษัทใด</p>
        <h3>สนใจรับบริการ</h3>
        <p>
          ปรึกษาบริการด้าน AI{' '}
          <a href='#contact' onClick={scrollTo}>
            กรอกฟอร์มนี้
          </a>
          <span>
            หรือโทร <a href='tel:020245560'>02-024-5560</a>
          </span>
        </p>
      </div>

      <ContactForm />
    </div>
  )
}
